<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="page_ii"><a id="lev01"></a><strong>STITCHING GUIDE</strong></p>
<table>
<tbody><tr>
<td class="borderb" valign="top"><p class="tablehead"><strong>Fabric</strong></p></td>
<td class="borderb" valign="top"><p class="tablehead"><strong>Threads/Yarn</strong></p></td>
<td class="borderb" valign="top"><p class="tablehead"><strong>Needles</strong></p></td>
</tr>
<tr>
<td class="borderb" valign="top"><p class="table">Plush, Velvets, and Wools</p></td>
<td class="borderb" valign="top"><p class="table">Silk Ribbon, Silk Buttonhole Twist, Embroidery Floss</p></td>
<td class="borderb" valign="top"><p class="table">Crewel No. 6, 7, 8 or Chenille No. 18-24</p></td>
</tr>
<tr>
<td class="borderb" valign="top"><p class="table">Cottons, Polyesters, Linens, and Shantungs</p></td>
<td class="borderb" valign="top"><p class="table">Embroidery Floss, Persian Wool, Perle Cotton, Tapestry Wool, Marlett, Metallics</p></td>
<td class="borderb" valign="top"><p class="table">Crewel No. 4, 5, 6, 7 or Tapestry No. 20 or 22</p></td>
</tr>
<tr>
<td class="borderb" valign="top"><p class="table">Moiré, Taffeta, Shot Cloths, and Satins</p></td>
<td class="borderb" valign="top"><p class="table">Embroidery Floss, Brazilian Embroidery Thread, Perle Cotton, Marlett, Metallics, Natesh®</p></td>
<td class="borderb" valign="top"><p class="table">Crewel No. 4, 5, 6, 7, 8</p></td>
</tr>
<tr>
<td class="borderb" valign="top"><p class="table">Lightweight Silks, Organzas, Batistes</p></td>
<td class="borderb" valign="top"><p class="table">Embroidery Floss, Brazilian Embroidery Thread, Cotton á Broder, Filo-Floss, Linen Thread, Marlett, Metallics, Natesh, Perle Cotton, Silk Buttonhole Twist</p></td>
<td class="borderb" valign="top"><p class="table">Crewel No. 6, 7, 8</p></td>
</tr>
<tr>
<td class="borderb" valign="top"><p class="table">Knits, Loosely Woven Fabrics</p></td>
<td class="borderb" valign="top"><p class="table">Persian Wool, Crewel Yarns</p></td>
<td class="borderb" valign="top"><p class="table">Chenille No. 18 or 20 or Tapestry No. 13, 16, or 18</p></td>
</tr>
<tr>
<td valign="top"><p class="table">Canvas for Needlepoint or Cross Stitch</p></td>
<td valign="top"><p class="table">Embroidery Floss, Brazilian Embroidery Thread, Cotton á Broder, Filo-Floss, Linen Thread, Marlett, Metallics, Natesh, Perle Cotton, Silk Buttonhole Twist, Silk Ribbon, Silk Sewing Thread, Soi d’ Algere, Stranded Embroidery Floss, Tapestry Wool, Ver a Soi</p></td>
<td valign="top"><p class="table">Tapestry No. 24 or 26 or Chenille No. 18-24</p></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781607053590_01_fmt.vue?4200e022